import { render, staticRenderFns } from "./CustomNote.vue?vue&type=template&id=329ae846&scoped=true&"
import script from "./CustomNote.vue?vue&type=script&lang=js&"
export * from "./CustomNote.vue?vue&type=script&lang=js&"
import style0 from "./CustomNote.vue?vue&type=style&index=0&id=329ae846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329ae846",
  null
  
)

export default component.exports